import { cva } from "class-variance-authority";
import type { Drawer as DrawerPrimitive } from "vaul";
import type { ExtendProps } from "@/lib/types";

export type DrawerCloseProps = ExtendProps<typeof DrawerPrimitive.Close>;

export type DrawerContentProps = ExtendProps<typeof DrawerPrimitive.Content>;

export type DrawerProps = ExtendProps<typeof DrawerPrimitive.Root>;

export type DrawerOverlayProps = ExtendProps<typeof DrawerPrimitive.Overlay>;

export type DrawerPortalProps = ExtendProps<typeof DrawerPrimitive.Portal>;

export type DrawerHeaderProps = ExtendProps<"div">;

export type DrawerFooterProps = ExtendProps<"div">;

export type DrawerTitleProps = ExtendProps<typeof DrawerPrimitive.Title>;

export type DrawerTriggerProps = ExtendProps<typeof DrawerPrimitive.Trigger>;

export type DrawerDescriptionProps = ExtendProps<
  typeof DrawerPrimitive.Description
>;

export const drawerContentVariants = cva(
  "fixed z-50 flex h-auto flex-col border bg-background",
  {
    variants: {
      direction: {
        right: "ml-24 right-0 rounded-l-[10px] inset-y-0",
        top: "mb-24 top-0 rounded-b-[10px] inset-x-0",
        bottom: "mt-24 rounded-t-[10px] bottom-0 inset-x-0",
        left: "mr-24 left-0 rounded-r-[10px] inset-y-0",
      },
    },
    defaultVariants: {
      direction: "right",
    },
  },
);
